import { render, staticRenderFns } from "./ProfileFormComponent.vue?vue&type=template&id=7c60530e&scoped=true"
import script from "./ProfileFormComponent.vue?vue&type=script&lang=js"
export * from "./ProfileFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c60530e",
  null
  
)

export default component.exports